// extracted by mini-css-extract-plugin
export var dataCell = "_l1-2";
export var dataRow = "_l1-0";
export var headerRow = "_l1-1";